// src/components/legal/TextoLegal.js
// =========================================================================
// TEXTO COMPLETO DE UN DOCUMENTO LEGAL (condiciones, encargado, verifactu)
// El texto llega ya relleno con los datos de Klyndu y de la clínica.
// =========================================================================
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Spinner } from '../common/ui';

export default function TextoLegal({ id, onCargado }) {
    const [doc, setDoc] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let activo = true;
        setDoc(null);
        setError('');
        api.get(`/legal/${id}`)
            .then((d) => { if (activo) { setDoc(d); onCargado?.(d); } })
            .catch((e) => { if (activo) setError(e.message || 'No se pudo cargar el texto.'); });
        return () => { activo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (error) return <p className="text-sm font-bold text-rose-700">{error}</p>;
    if (!doc) return <div className="flex justify-center py-6"><Spinner /></div>;

    const fecha = new Date(doc.fecha).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
    return (
        <article className="space-y-4 text-sm text-slate-700 leading-relaxed">
            <p className="text-xs font-bold text-slate-400">Versión {doc.version} · {fecha}</p>
            {doc.secciones.map((s, i) => (
                <section key={s.titulo}>
                    <h3 className="mb-1 text-sm font-black text-slate-900">{i + 1}. {s.titulo}</h3>
                    {s.parrafos.map((p) => <p key={p} className="mb-2 font-medium">{p}</p>)}
                </section>
            ))}
        </article>
    );
}
